import React from 'react';
interface IconProps {
    width?: number;
    height?: number;
}

const LoaderDotsIcon = (props: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
                margin: 'auto',
                background: '0 0',
            }}
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            display="block"
            {...props}>
            <g transform="translate(20 50)">
                <circle r={6} fill="#0028d1" transform="scale(.86881)">
                    <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.375s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </circle>
            </g>
            <g transform="translate(40 50)">
                <circle r={6} fill="#0028d1" transform="scale(.5465)">
                    <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.25s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </circle>
            </g>
            <g transform="translate(60 50)">
                <circle r={6} fill="#0028d1" transform="scale(.20501)">
                    <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.125s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </circle>
            </g>
        </svg>
    );
};

export default LoaderDotsIcon;
